import * as React from 'react';
import { DURATION_SLOW } from '../../constants';
export function useAnimationStage(isOpen, delayBeforeAnimatingIn = 0, durationToAnimateOut = DURATION_SLOW) {
    const [animationStage, setAnimationStage] = React.useState('hidden');
    const timeoutRef = React.useRef();
    React.useEffect(() => {
        if (isOpen && animationStage === 'hidden') {
            setAnimationStage('transitioning');
        }
        else if (!isOpen && animationStage === 'visible') {
            setAnimationStage('transitioning');
        }
    }, [isOpen, animationStage, setAnimationStage]);
    React.useLayoutEffect(() => {
        if (animationStage === 'transitioning' && !timeoutRef.current) {
            if (isOpen === true) {
                timeoutRef.current = window.setTimeout(() => {
                    timeoutRef.current = undefined;
                    setAnimationStage('visible');
                }, delayBeforeAnimatingIn);
            }
            else {
                timeoutRef.current = window.setTimeout(() => {
                    timeoutRef.current = undefined;
                    setAnimationStage('hidden');
                }, durationToAnimateOut);
            }
        }
        return () => {
            timeoutRef.current && window.clearTimeout(timeoutRef.current);
        };
    }, [isOpen, animationStage, delayBeforeAnimatingIn, durationToAnimateOut]);
    return animationStage;
}
//# sourceMappingURL=useAnimationStage.js.map